import { render, staticRenderFns } from "./Grids.vue?vue&type=template&id=c767e2aa"
import script from "./Grids.vue?vue&type=script&lang=js"
export * from "./Grids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c767e2aa')) {
      api.createRecord('c767e2aa', component.options)
    } else {
      api.reload('c767e2aa', component.options)
    }
    module.hot.accept("./Grids.vue?vue&type=template&id=c767e2aa", function () {
      api.rerender('c767e2aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/grid/Grids.vue"
export default component.exports